import React, { useState } from 'react';
import CommonTable from '../../../../global/table';
import NoRecordFound from '../../../../global/noRecordFound';
import CommonCardView from '../../../../global/cardView';
import EnhancedLeadsNotSentCardView from './enhancedLeadsNotSentCardView';
import { useQueryClient } from '@tanstack/react-query';
import { QUERY_OPTIONS } from '../../../../../lib/query-constants';
import { useHistory, Redirect } from "react-router-dom"

const EnhancedLeadsNotSentList = ({
    isLoading,
    noLeadsSend,
    viewDetail,
    sort,
    setSort,
    viewType,

}) => {
    const [leadDetails, setLeadDetails] = useState({
        show: false,
        data: null
    });

    // queryClient
    const queryClient = useQueryClient();
    const navigate = useHistory();

    const onLeadClick = (lead) => {
        const leadId = lead?.originalData?.user?.userId ?? ""
        queryClient.setQueryData(["leadNotSent", leadId], lead?.originalData);
        queryClient.setQueryDefaults(["leadNotSent", leadId], {
            staleTime: 60 * 60 * 1000, // 1 hour,
            gcTime: 60 * 60 * 1000 // 1 hour
        });

        navigate.replace(`/admin/lead-not-send-details?leadId=${leadId}`);
    };

    // Columns Configuration
    const columns = [
        {
            title: "Client Name",
            dataIndex: "clientName",
            key: "clientName",
            sortType: "Client Name",
            isAvatar: true
        },
        {
            title: "Client Email",
            dataIndex: "userEmail",
            key: "userEmail",
            sortType: "Client Email",
            render: (text, record) => (
                <p className="text-primary cursor-pointer hover:underline">{text}</p>
            ),
        },
        {
            title: "Client Phone",
            dataIndex: "clientPhone",
            key: "clientPhone",
            sortType: "Client Phone",
        },
        {
            title: "On Trial",
            dataIndex: "onTrial",
            key: "onTrial",
            sortType: "On Trial",
        },
        {
            title: "Count",
            dataIndex: "count",
            key: "count",
            sortType: "Count",
            render: (text, record) => (
                <p className="text-primary">
                    {text}
                </p>
            ),
        },
    ];

    // Data Mapping
    const data = Array.isArray(noLeadsSend) && noLeadsSend.length > 0
        ? noLeadsSend.map((item) => ({
            key: item._id || item.userEmail,
            id: item._id || item.userEmail,
            userEmail: item?.userEmail,
            clientName: item?.user?.name,
            clientPhone: item?.user?.phone,
            onTrial: item?.user?.isTrial,
            count: item?.count,
            originalData: item, // Keep original data for viewDetail
        }))
        : [];


    return (
        <>
            {data.length > 0 ? (
                <>
                    {viewType === "LIST" ? (
                        <CommonTable
                            columns={columns}
                            data={data}
                            onRowClick={(record) => onLeadClick(record)}
                        />
                    ) : (
                        <CommonCardView>
                            {data.map((record) => (
                                <EnhancedLeadsNotSentCardView
                                    key={record.id}
                                    record={record}
                                    onCardClick={(record) => onLeadClick(record)}
                                />
                            ))}
                        </CommonCardView>
                    )}
                </>
            ) : (
                <NoRecordFound message="No leads found." />
            )}
        </>
    );
};

export default EnhancedLeadsNotSentList;
